import { Component } from 'preact'
/* eslint-disable-next-line import/no-internal-modules */
import UserOverview, { UserOverviewProps } from '@insided/deprecated-control/UserOverview/Index'
// eslint-disable-next-line import/no-internal-modules
import { Filters } from '@insided/deprecated-control/overview'
// eslint-disable-next-line import/no-internal-modules
import tracker from '@insided/deprecated-components/tracker/publish'
import { SegmentData } from './types'
import { filterValueListToFilters } from './utils'
import { HeaderActionsComponent } from './HeaderActions'
import SegmentDashboard from './SegmentDashboard'

export interface UserSegmentProps extends UserOverviewProps {
  segmentData: SegmentData
}

interface State {
  updatedDescription: string
  updatedTitle: string
  totalMatchingUsers: number
}

class UserSegment extends Component<UserSegmentProps, State> {
  filters: Filters
  rootComponent?: UserOverview

  constructor(props: UserSegmentProps) {
    super(props)

    const {
      segmentData: { segment: { description, title, filters: filtersProp } },
      customProfileFields,
      ranks,
      badges,
      groups,
      roles: { mainRoles, customRoles }
    } = props

    this.filters = filterValueListToFilters(filtersProp, {
      customRoles,
      mainRoles,
      customProfileFields,
      ranks,
      badges,
      groups
    })

    this.state = {
      updatedDescription: description,
      updatedTitle: title,
      totalMatchingUsers: 0
    }
  }

  componentDidMount() {
    const { segmentData: { segment: { title } } } = this.props

    tracker.trackEvent('userevent', {
      type: 'Segment detail viewed',
      title
    })
  }

  resetFilters = () => {
    const { segmentData: { segment: { title, description } } } = this.props
    this.setState({
      updatedDescription: description,
      updatedTitle: title
    }, () => this.rootComponent?.resetFilters())
  }

  onTitleUpdated = (newValue: string) => {
    this.setState({ updatedTitle: newValue })
  }

  onDescriptionUpdated = (newValue: string) => {
    this.setState({ updatedDescription: newValue })
  }

  render() {
    const { segmentData: { segment: { id, title, description } }, ...userOverviewProps } = this.props
    const { customProfileFields } = userOverviewProps
    const { updatedDescription, updatedTitle } = this.state

    return (
      <UserOverview
        ref={node => { this.rootComponent = node }}
        {...userOverviewProps}
        type={`UserSegment-${id}`}
        title={updatedTitle}
        source='Segment details'
        onTitleChanged={this.onTitleUpdated}
        onDataFetched={({ total }) => this.setState({ totalMatchingUsers: total })}
        defaultFilters={this.filters}
        StateAwareHeaderComponent={props => (
          <HeaderActionsComponent
            {...props}
            customProfileFields={customProfileFields}
            id={id}
            title={updatedTitle}
            description={updatedDescription}
            isTitleChanged={title !== updatedTitle}
            isDescriptionChanged={description !== updatedDescription}
            onTitleUpdated={this.onTitleUpdated}
            onCancel={this.resetFilters}
          />
        )}
        StateAwareDashboardComponent={() => (
          <SegmentDashboard
            segmentData={this.props.segmentData}
            totalMatchingUsers={this.state.totalMatchingUsers}
            description={updatedDescription}
            onDescriptionUpdated={this.onDescriptionUpdated}
          />
        )}
      />
    )
  }
}

export default UserSegment
